import type {
  FairDropdownFlatItem,
  FairDropdownGroup,
  FairDropdownOption,
  FairDropdownOptions,
} from '@/ui/tokens/inputs.data'
import { isGroupedDropdownOptions } from '@/ui/tokens/inputs.data'

export function flattenDropdownOptions(
  source: FairDropdownOptions,
): FairDropdownFlatItem[] {
  if (!source.length) {
    return []
  }

  if (isGroupedDropdownOptions(source)) {
    return flattenGrouped(source)
  }

  return source.map((option) => ({
    kind: 'option' as const,
    key: option.key,
    option,
  }))
}

function flattenGrouped(groups: FairDropdownGroup[]): FairDropdownFlatItem[] {
  const items: FairDropdownFlatItem[] = []

  for (const group of groups) {
    items.push({
      kind: 'group',
      key: group.key,
      group,
    })

    for (const option of group.items) {
      items.push({
        kind: 'option',
        key: option.key,
        option,
      })
    }
  }

  return items
}

export function findDropdownOption(
  source: FairDropdownOptions,
  key: string | null | undefined,
): FairDropdownOption | undefined {
  if (!key) {
    return undefined
  }

  const flat = flattenDropdownOptions(source)

  return flat.find((item) => item.kind === 'option' && item.key === key)?.option
}
